import React from 'react';

export const ConsumerReports = () => {
  return (
    <section className="container-terms">
      <h1 className="header-black">
        Consumer Reports
        <br />
        <span className="header-gray">
          Including Credit and Insurance Credit Score
        </span>
      </h1>
      <div>
        <p>
          As part of this insurance quote and any subsequent policy and renewal,
          we may obtain and use Consumer Report information from one or more
          companies specializing in information from consumer reporting
          agencies. This includes your driving record, vehicle, policy and
          claims history with other insurers, and credit report information, and
          we do this in compliance with applicable state law.
        </p>
        <p>
          We may review your credit report or obtain and use an insurance credit
          score based on the information contained in that credit report. Our
          inquiry will not affect your credit score or credit rating, nor be
          seen by other companies.
        </p>
        <p>
          If you decide to purchase a policy with Stillwater we’ll confirm and
          use information related to the type of policy selected, such as your
          claims history, driving records and other data of all listed drivers,
          possible drivers in your household and your insurance credit score.
        </p>
        <p>
          Upon renewal and as permitted by law, we may also review and use
          similar information.
          <br />
        </p>
        <p>
          If the rate of your Stillwater policy was adversely impacted by your
          insurance credit score, we will provide the name and address of the
          consumer agency that provided us with the information. This will
          include their contact information so that you can contact them for a
          copy of your complete credit report.
        </p>
        <p>
          You may request your credit information be updated and if you question
          the accuracy of the credit information, we will, upon your request,
          reevaluate you based on corrected credit information from a consumer
          reporting agency.
        </p>
        <p>
          Additionally, you’re entitled to one free credit report each year from
          each of the three major credit bureaus: <ins>Experian</ins>,{' '}
          <ins>Equifax</ins>, and <ins>TransUnion</ins>. It’s recommended that
          you should review the reports from all three bureaus annually.
        </p>
      </div>
    </section>
  );
};
export default ConsumerReports;
